<template>
  <div>
    <div v-if="modal === 1" :class="{'is-pdv': isPdv}" class="modal-pdv modal-small show" tabindex="0">
      <div class="modal-pdv-content">
        <div class="pagamento-content">
          <loading v-if="load"/>
          <div class="container-fluid p-3" v-show="!load" v-if="comanda">
            <div class="row no-gutters">
              <div class="col-lg-12">
                <div class="border rounded p-2 d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <div><b>Venda</b></div>
                    <div class="small">Subtotal: </div>
                    <div class="small" v-if="dados.taxa_servico > 0">Taxa de Serviço: </div>
                    <div class="small" v-if="dados.estacionamento > 0">Estacionamento: </div>
                    <div class="small" v-if="dados.cover > 0">Cover: </div>
                    <div class="small" v-if="dados.frete > 0">Taxa de Entrega: </div>
                    <div class="small">Desconto: </div>
                    <div class="">Total a Pagar: </div>
                  </div>
                  <div class="text-right">
                    <div><b>{{ comanda.id_contador }}</b></div>
                    <div class="small">{{totalComanda | valor}}</div>
                    <div class="small" v-if="dados.taxa_servico > 0">(+) {{dados.taxa_servico | valor}}</div>
                    <div class="small" v-if="dados.estacionamento > 0">(+) {{dados.estacionamento | valor}}</div>
                    <div class="small" v-if="dados.cover > 0">(+) {{dados.cover | valor}}</div>
                    <div class="small" v-if="dados.frete > 0">(+) {{dados.frete | valor}}</div>
                    <div class="small">(-) {{dados.desconto | valor}}</div>
                    <h5 class="m-0"><b>{{totalPagar | valor}}</b></h5>
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="card-pagamento">
                  <div class="row no-gutters">
                    <div class="col-sm-6 mb-2 pr-sm-1">
                      <label class="mb-0">Pagamento</label>
                      <div class="d-flex align-items-end">
                        <select title="Forma de Pagamento" class="form-control mr-1" v-model="forma_pagamento">
                          <option :value="f.id_pagamento" v-for="f in formas_pagamento">{{f.nome_pagamento}}</option>
                        </select>
                        <div><button class="btn btn-warning" @click="editarPagamento()"><i class="fa fa-search"></i></button></div>
                      </div>
                    </div>
                    <div v-if="forma_pagamento !== '2'" class="col-sm-6 mb-2 pl-sm-1">
                      <label class="mb-0">Valor</label>
                      <div class="d-sm-flex justify-content-between align-items-center">
                        <money v-model="valor_pagamento" class="form-control" id="inserirPagamento"
                               @keydown.enter.native="incluirPagamentoForm()"
                               :disabled="totalRecebido === totalPagar"/>
                        <div class="mt-2 mt-sm-0 ml-sm-1">
                          <button class="btn btn-info btn-block" @click="incluirPagamentoForm()" :disabled="totalRecebido === totalPagar">
                            <i class="fa fa-plus"></i> <span class="d-sm-none ml-1">Inserir Pagamento</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-else class="col-sm-6 mb-2 pl-sm-1">
                      <label class="mb-0 text-center">Dividir</label>
                      <div class="d-sm-flex">
                        <input v-model="qtdDividir" :disabled="totalRecebido === totalPagar" class="form-control" min="1" placeholder="Ex: 2" type="number" @keyup.enter="dividirConta()"/>
                        <button :disabled="totalRecebido === totalPagar" class="btn btn-third ml-sm-1 text-nowrap" title="Dividir a quantidade de pagamentos" @click="dividirConta()">
                          <i class="fa fa-divide"></i><span class="d-sm-none ml-2">Dividir Conta</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="border rounded height-50">
                  <table class="table table-sm">
                    <thead class="bg-light small">
                    <tr>
                      <th>Pagamento / Valor</th>
                      <th class="text-center" style="width: 50px">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="p in dados.pagamentos">
                      <td class="pointer" @click="editarPagamento(p)">
                        <div>{{p.valor | valor}}</div>
                        <div class="text-ellipsis small" :title="p.observacao" style="width: 140px" v-if="p.id_voucher">
                          <i class="fa fa-star text-warning"></i> <span class="small">Voucher: {{p.observacao}}</span>
                        </div>
                        <div class="text-ellipsis small" :title="p.nome_pagamento" style="width: 140px" v-else>{{ p.nome_pagamento }}</div>
                        <div class="small" :title="p.observacao" style="width: 140px" v-if="p.observacao"><b>Obs:</b> {{ p.observacao }}</div>
                      </td>
                      <td class="text-nowrap text-center">
                        <a href="javascript:" class="btn btn-sm btn-primary mr-1" @click="editarPagamento(p, true)" title="Editar Pagamento" style="width: 36px">
                          <i class="fa fa-pencil-alt"></i>
                        </a>
                        <a href="javascript:" class="btn btn-sm btn-dark" @click="removerPagamento(p)" title="Remover Pagamento" style="width: 36px">
                          <i class="fa fa-trash-alt"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <hr class="d-lg-none">
                <div class="mt-2 mb-3 mb-lg-0 font-weight-bold">
                  <div v-if="dados.troco > 0.01">
                    <span class="float-right">{{dados.troco | valor }}</span>
                    <div>Troco: </div>
                  </div>
                  <div v-if="totalRecebido < totalPagar">
                    <span class="float-right">{{(totalPagar - totalRecebido) | valor}}</span>
                    <div>Falta Receber: </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="fechar">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
          <button class="btn btn-success p-3 px-4" id="btnFinalizar" @click="finalizaVenda()" :disabled="totalRecebido < totalPagar" v-if="!load">
            <span>Finalizar</span>
            <i class="fa fa-check ml-2"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="modal-pdv modal-small show" id="modalOutrosPagamentos" tabindex="0" v-if="modal === 2" :class="{'is-pdv': isPdv}">
      <div class="modal-pdv-content">
        <div class="container-fluid p-0 pt-3">
          <h6 class="font-weight-bold text-center mb-0">Selecione um pagamento</h6>
          <hr>
          <div class="px-3">
            <input type="search" class="form-control" id="termPagamentoSimples" v-model="termPagamento" @keyup="pesquisarPagamentos" placeholder="Pesquisar"
                   @keyup.down="$helpers.focusElement('btnPagS0')" @keyup.esc="closeModal()">
          </div>
          <div class="height-90 py-2">
            <div class="mx-3">
              <a href="javascript:" tabindex="0" class="d-block py-2 border-bottom px-1 py-3 text-decoration-none text-dark"
                 v-for="(p, index) in searchPagamentos" :id="'btnPagS' + index"
                 @keyup.down="$helpers.focusElement('btnPagS' + (index + 1))"
                 @keyup.up="index > 0 ? $helpers.focusElement('btnPagS' + (index - 1)) : $helpers.focusElement('termPagamentoSimples')"
                 @keyup.esc="closeModal('btnPagSOutros')"
                 @click="selPagamento(p)">
                {{p.nome_pagamento}} <span class="badge badge-primary ml-1" v-if="pagEdit && pagEdit.id_pagamento === p.id_pagamento"><i class="fa fa-check"></i></span>
              </a>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="closeModal('btnPagSOutros')">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
        </div>
      </div>
    </div>

    <editar-pagamento ref="editarPag" :formas_pagamento="formas_pagamento" @salvar="salvarPagamento" gestor="true"/>
    <caixa ref="modalCaixa" :isPdv="isPdv" @finalizarVenda="finalizaVenda"/>
    <modal-option @imprimir="imprimirVenda" gestor="true" :empresa="empresa"/>
  </div>
</template>

<script>
  import Caixa from './Caixa'
  import IconDelete from "../../../components/pdv/IconDelete";
  import ModalOption from "@/components/pdv/ModalOption";
  import Loading from "@/components/gestor/loading";
  import EditarPagamento from "@/views/comanda/pdv/EditarPagamento";

  export default {
    name: "FinalizarSimples",
    components: {EditarPagamento, Loading, ModalOption, IconDelete, Caixa},
    props: ['isPdv'],
    data() {
      return {
        token: localStorage.getItem('key'),
        modal: 0,
        modificou: false,
        load: true,
        comanda: null,
        totalComanda: 0,
        totalPagar: 0,
        totalRecebido: 0,
        qtdDividir: 1,

        obs_pagamento: "",
        forma_pagamento: '1',
        valor_pagamento: 0,
        searchPagamentos: [],
        termPagamento: '',
        pagEdit: null,
        empresa: {},

        dados: {
          pagamentos: [],
          desconto: 0,
          troco: 0,
          frete: 0,
          estacionamento: 0,
          cover: 0,
          taxa_servico: 10,
          id_zona: null,
          id_pedido: null
        }
      }
    },

    methods: {
      clear() {
        this.$emit('clearVoucher');
        this.modificou = false;
        this.totalRecebido = 0;
        this.qtdDividir = 1;
        this.valor_pagamento = 0;
        this.termPagamento = '';
        this.pagEdit = null;
        this.dados = {
          pagamentos: [],
          desconto: 0,
          troco: 0,
          frete: 0,
          estacionamento: 0,
          cover: 0,
          id_pedido: null,
          id_zona: null,
          taxa_servico: 0
        };
      },

      openModal() {
        this.clear();

        if (!this.formas_pagamento.length) {
          this.$swal("Não existem formas de pagamentos cadastradas no sistema!");
          return;
        }

        this.modal = 1;
      },

      atualizarCampoPagamento() {
        this.valor_pagamento = this.totalRecebido < this.totalPagar ? (this.totalPagar - this.totalRecebido) : 0;
      },

      incluirPagamentoForm(valor, id_voucher, id_tabela_preco) {
        const raw = valor ?? this.valor_pagamento;
        const num = parseFloat(raw);

        if (!num || isNaN(num) || num <= 0) {
          this.valor_pagamento = 0;
          return;
        }

        this.valor_pagamento = this.normalizeValor(num);

        if (parseInt(this.forma_pagamento) !== 1 && (this.valor_pagamento > this.normalizeValor(this.totalPagar - this.totalRecebido))) {
          this.$swal("Esta forma de pagamento não permite troco!").then();
          this.obs_pagamento = '';
          return;
        }

        this.modificou = true;
        this.incluirPagamento({ id_voucher, id_tabela_preco });
        this.atualizarCampoPagamento();
      },

      incluirPagamento(obj) {
        if (!this.valor_pagamento) {
          return;
        }

        let pagamento;

        if (this.totalRecebido + this.valor_pagamento <= this.totalPagar) {
          this.totalRecebido += this.valor_pagamento;
          pagamento = this.valor_pagamento;

        } else {
          if (parseInt(this.forma_pagamento) === 1) {
            const troco = this.totalRecebido + this.valor_pagamento - this.totalPagar;
            this.dados.troco = (troco > 0 && troco < 200) ? troco : 0;
          }

          pagamento = (this.totalPagar - this.totalRecebido);

          if (pagamento <= 0) {
            return;
          }

          this.totalRecebido += pagamento;
        }

        const objPag = this.pagamentos.find(p => p.id_pagamento === this.forma_pagamento) || {};
        const dados = {
          nome_pagamento: objPag.nome_pagamento || '',
          data_vencimento: obj.data_vencimento || '',
          id_pagamento: this.forma_pagamento,
          observacao: this.obs_pagamento,
          online: obj.categoria === '5',
          valor: pagamento
        };

        if (obj.id_comanda_pagamento) {
          dados.id_comanda_pagamento = obj.id_comanda_pagamento;
        }

        if (obj.id_voucher) {
          dados.id_voucher = obj.id_voucher;
          dados.id_tabela_preco = obj.id_tabela_preco || null;
        }

        this.dados.pagamentos.push(dados);
        this.obs_pagamento = "";
        this.valor_pagamento = 0;
        this.forma_pagamento = obj.id_voucher ? '1' : this.forma_pagamento;
        this.totalRecebido = this.normalizeValor(this.totalRecebido);
      },

      removerPagamento(p) {
        if (p.online) {
          this.$swal('Não é possível editar um Pagamento Online');
          return;
        }

        const index = this.dados.pagamentos.indexOf(p);
        if (index === -1) return;

        this.totalRecebido -= this.dados.pagamentos[index].valor;
        this.dados.pagamentos.splice(index, 1);
        this.modificou = true;

        this.dados.troco =  this.totalRecebido > this.totalPagar ? (this.totalRecebido - this.totalPagar) :  0;
        this.atualizarCampoPagamento();
      },

      editarPagamento(p, detalhar) {
        if (detalhar) {
          this.$refs.editarPag.openEditar({
            index: this.dados.pagamentos.indexOf(p),
            id_pagamento: p.id_pagamento,
            id_voucher: p.id_voucher || null,
            valor: p.valor,
            data_vencimento: p.data_vencimento || '',
            observacao: p.observacao,
            online: p.online
          });

        } else if (!p || (!p.id_voucher && !p.online)) {
          this.pagEdit = p || null;
          this.searchPagamentos = this.formas_pagamento;
          this.termPagamento = '';
          this.modal = 2;
          this.$nextTick(() => {
            this.$helpers.focusElement('termPagamentoSimples');
          });

        } else {
          this.$swal('Não é possível editar um' + (p.id_voucher ? ' Voucher' : ' Pagamento Online'));
        }
      },

      pesquisarPagamentos() {
        if (this.termPagamento.trim().length) {
          this.searchPagamentos = this.formas_pagamento.filter(p => p._texto.toLowerCase().includes(this.termPagamento.toLowerCase()));

        } else {
          this.searchPagamentos = this.formas_pagamento;
        }
      },

      salvarPagamento(dados) {
        if (dados.index < this.dados.pagamentos.length) {
          const pagamento = this.dados.pagamentos[dados.index];
          pagamento.id_pagamento = dados.id_pagamento;
          pagamento.nome_pagamento = (this.pagamentos.find(p => p.id_pagamento === pagamento.id_pagamento) || {}).nome_pagamento || '';
          pagamento.data_vencimento = ['2','44'].includes(pagamento.id_pagamento) ? dados.data_vencimento : '';
          pagamento.observacao = dados.observacao;
        }
      },

      selPagamento(p) {
        this.modal = 1;

        if (this.pagEdit) {
          this.pagEdit.nome_pagamento = p.nome_pagamento;
          this.pagEdit.id_pagamento = p.id_pagamento;
          this.pagEdit = null;

        } else {
          this.forma_pagamento = p.id_pagamento;
          this.$helpers.selectElement('inserirPagamento');
        }
      },

      finalizaVenda() {
        if (this.load) return;
        this.load = true;

        if (!this.comanda) {
          this.$emit('reprocessar');
          this.load = false;
          return;
        }

        if (this.dados.pagamentos.find(p => ['2','34','44'].includes(p.id_pagamento)) && !this.comanda.id_cliente) {
          this.$swal('Por favor, acesse o PDV e informe um cliente na venda');
          this.load = false;
          return;
        }

        if (this.comanda.itens.length <= 0) {
          this.$swal("Atenção!","Você não pode finalizar um venda que não tenha nenhum produto.");
          this.load = false;
          return;
        }

        if (this.totalRecebido < this.totalPagar) {
          this.$swal("Para finalizar esta venda informe o valor que falta receber");
          this.load = false;
          return;
        }

        this.modal = 1;
        this.dados.status = 2;
        this.dados.id_comanda = this.comanda.id_comanda;
        this.dados.id_cliente = this.comanda.id_cliente;

        this.$http.post('pdv/finalizar/' + this.token, this.dados)
          .then(response => {
            this.load = false;

            if (response.data.result) {
              switch (response.data.result) {
                case 'success':
                  this.$emit('atualizar');

                  this.$swal({
                    title: '',
                    text: 'Deseja imprimir o comprovante desta venda?',
                    buttons: ['Não','Sim'],
                    dangerMode: true
                  }).then((r) => {
                    if (r) {
                      this.comanda.status = '2';
                      this.$emit('abrirComprovante', this.comanda);
                    }
                  });

                  if (this.dados.pagamentos.find(p => p.id_pagamento === '44')) {
                    const portal = this.$helpers.getUrlPortal();
                    const contas = response.data.payload?.contas || [];
                    window.open(portal + 'financeiro/receber#' + contas[0]);
                  }

                  this.closeModal();
                  break;

                case 'caixa':
                  this.modal = 0;
                  this.$refs.modalCaixa.abrirCaixa(response.data.id_empresa);
                  break;
                  
                default:
                  this.$swal("Atenção!", response.data.message);
                  break;
              }
            }

          }, res => {
            this.load = false;
            this.dados.status = 1;
            this.$swal(res.data.msg);
          });
      },

      closeModal() {
        if (this.modal === 1) {
          this.$helpers.toggleModal(false);
          this.modal = 0;
          this.$emit('cancelar');
          this.clear();

        } else if (this.modal > 1) {
          this.modal = 1;
        }
      },

      fechar() {
        if (this.comanda && this.comanda.status === '1' && this.modificou) {
          this.$swal({
            title: '',
            text: 'Deseja sair sem salvar os pagamentos?',
            buttons: ['Não','Sim'],
            dangerMode: true
          }).then((r) => {
            if (r) {
              this.closeModal();
            }
          })

        } else {
          this.closeModal();
        }
      },

      dividirConta() {
        if (!this.comanda || this.comanda.status !== '1') {
          return;
        }

        this.atualizarCampoPagamento();
        const restante = this.normalizeValor(this.totalPagar - this.totalRecebido);

        if (this.valor_pagamento > restante) {
          this.$swal("O valor a pagar não pode ser maior que o valor restante!");
          return;
        }

        if (this.qtdDividir > 0) {
          let total = this.valor_pagamento;
          let soma = 0;

          for (let i = 0; i < this.qtdDividir; i++) {
            let pagamento = (total / this.qtdDividir);

            if (parseInt(this.qtdDividir) === (i+1)) {
              pagamento = (pagamento > (this.totalPagar - this.totalRecebido)) ? (this.totalPagar - this.totalRecebido) : (total - soma);
            }

            if (pagamento > 0) {
              soma += this.normalizeValor(pagamento);
              this.incluirPagamentoForm(pagamento);
            }
          }
        }
      },

      normalizeValor(valor) {
        const num = Number(valor);
        if (!isFinite(num)) return 0;
        return parseFloat(num.toFixed(2));
      },

      imprimirVenda(id_comanda) {
        if (!id_comanda) {
          return;
        }

        const url = this.base_server + "api/comprovante/" + this.empresa.token + "/" + id_comanda + "?";
        this.$helpers.imprimirUrl(this, url, this.empresa.token, "Comprovante " + id_comanda);
      },

      finalizarPedidoVenda(id_comanda, id_pedido) {
        this.load = true;
        this.openModal();

        this.$http.get('comandas/' + this.token + '/' + id_comanda)
          .then(response => {
            this.load = false;

            if (response.data.id_comanda) {
              let total = 0;
              this.comanda = response.data;

              if (!this.comanda.itens.length) {
                this.$swal("Esta venda não possui nenhum item para ser fechada");
                return;
              }

              if (this.comanda.status !== '1') {
                this.closeModal();
                this.$emit('atualizar', true);
                return;
              }

              this.comanda.itens.forEach((obj) => {
                total += parseFloat(obj.valor_total);
              });

              this.empresa = this.comanda.id_empresa ? this.empresas.find(e => e.id_empresa === this.comanda.id_empresa) : null;

              if (!this.empresa) {
                this.$swal('Não foi possível identificar a empresa desta venda.');
                this.closeModal();
                return;
              }

              this.totalComanda = parseFloat(total.toFixed(2));
              this.dados.troco = this.comanda.troco && this.comanda.troco ? this.comanda.troco : 0;
              this.dados.desconto = this.comanda.desconto ? this.comanda.desconto : 0;
              this.dados.frete = this.comanda.frete || 0;
              this.totalPagar = this.normalizeValor(this.totalComanda - parseFloat(this.dados.desconto) + parseFloat(this.dados.frete));
              this.dados.id_pedido = id_pedido;

              if (this.comanda.pagamentos.length === 0) {
                this.valor_pagamento = this.totalPagar;
                this.forma_pagamento = '1';

              } else {
                this.comanda.pagamentos.forEach(obj => {
                  this.obs_pagamento = obj.observacao;
                  this.forma_pagamento = obj.id_pagamento;
                  this.valor_pagamento = parseFloat(obj.valor);
                  this.incluirPagamento(obj);
                });

                this.forma_pagamento = '1';
                this.atualizarCampoPagamento();
              }
            }

          }, res => {
            this.load = false;
          });
      },

      finalizarPedidoCaixa(id_empresa) {
        this.comanda = null;
        this.$refs.modalCaixa.abrirCaixa(id_empresa);
      }
    },

    computed: {
      pagamentos() {
        return this.$store.state.pagamentos;
      },

      pagamentos_empresa() {
        return this.$store.state.pagamentos_empresa;
      },

      empresas() {
        return this.$store.state.empresas
      },

      formas_pagamento() {
        return (this.pagamentos_empresa || []).map(opt => { return { ...opt, _texto: opt.nome_pagamento.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()}});
      }
    }
  }
</script>

<style scoped>
.modal-pdv .modal-pdv-content {
  margin-top: 72px;
  height: calc(100vh - 86px);
  padding-top: 0;
}

.modal-pdv.is-pdv .modal-pdv-content {
  margin-top: 48px;
}

.pagamento-content {
  height: calc(100vh - 164px);
  overflow: auto;
}

.height-50 {
  height: calc(100vh - 440px);
}

.height-90 {
  height: calc(100vh - 270px);
}

@media (max-width: 991px) {
  .card-pagamento {
    border: 1px solid #dddfeb;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;
    background-color: var(--light);
  }

  .pagamento-content {
    height: auto;
  }
}
</style>
